export enum VARIANT {
  GREEN = 'green',
  BLUE = 'blue',
  PURPLE = 'purple'
}
